/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespInteriorsPhotoCarousel_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedInteriorsHeader_itemSearch">;
    readonly " $refType": "SbRespInteriorsPhotoCarousel_itemSearch";
};
export type SbRespInteriorsPhotoCarousel_itemSearch$data = SbRespInteriorsPhotoCarousel_itemSearch;
export type SbRespInteriorsPhotoCarousel_itemSearch$key = {
    readonly " $data"?: SbRespInteriorsPhotoCarousel_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespInteriorsPhotoCarousel_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespInteriorsPhotoCarousel_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedInteriorsHeader_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '1a9d9ca9cc0322423cbc2d7f1ed8142a';
export default node;
